import React from "react";
import { useEffect, useState } from "react";
import netlifyIdentity from "netlify-identity-widget";
import Routing from "./routes";
import { InvoiceProvider } from "./InvoiceContext";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    netlifyIdentity.init();

    netlifyIdentity.on("login", (user) => {
      setUser(user);
      netlifyIdentity.close();
    });

    netlifyIdentity.on("logout", () => {
      setUser(null);
    });
  }, []);

  return (
    <InvoiceProvider>
      <div style={{ padding: "10px", maxWidth: "816px", margin: "0 auto" }}>
        <Routing user={user} />
      </div>
    </InvoiceProvider>
  );
}

export default App;
